import baseTheme from '../baseTheme';
import colors from '../colors';
export var MuiLink = {
    root: {
        position: 'relative',
        color: colors.blue[700],
        fontSize: baseTheme.typography.body1.fontSize,
        fontFamily: baseTheme.typography.fontFamily,
        lineHeight: 1.5,
        '&:not([class^="MuiButton"])': {
            fontWeight: baseTheme.typography.body1.fontWeight,
        },
        // Don't show hover bubble for underline=none. The
        // hardcoded color is blue[700] with 13% opacity
        '&:not(.MuiLink-underlineNone)': {
            transition: 'background-size 0.15s ease',
            backgroundImage: "linear-gradient(rgba(0, 123, 155, 0.13), rgba(0, 123, 155, 0.13))",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0 88%',
            backgroundSize: '100% 0em',
            borderRadius: '2em',
            '&:not([class^="MuiButton"])': {
                margin: '0 -0.3em',
            },
        },
        '& .FoundryLinkSpan': {
            display: 'inherit',
            alignItems: 'center',
        },
        '&:hover': {
            textDecorationLine: 'none',
            backgroundSize: '100% 100%',
            '& .FoundryLinkSpan': {
                borderBottomColor: 'transparent',
            },
        },
    },
    button: {
        verticalAlign: 'initial',
        userSelect: 'initial',
        fontSize: '1em',
    },
    underlineAlways: {
        padding: '0.1em 0.3em',
        textDecorationLine: 'none',
        '& .FoundryLinkSpan': {
            borderBottomStyle: 'solid',
            borderBottomWidth: 'thin',
            borderBottomColor: 'rgb(0, 123, 155)',
            transition: 'border-bottom-color .15s',
        },
    },
    underlineHover: {
        textDecorationLine: 'none',
        padding: '0em 0.3em',
        '&:hover': {
            textDecorationLine: 'none',
        },
    },
    underlineNone: {
        textDecorationLine: 'none',
    },
};
//# sourceMappingURL=MuiLink.js.map